import Modal from './src/modal'
import Modals from './src/modal1'
import Dialog from './src/Dialog'
Modal.install = function (Vue) {
  Vue.component(Modal.name, Modal)
}
Modals.install = function (Vue) {
  Vue.component(Modals.name, Modals)
}
Dialog.install = function (Vue) {
  Vue.component(Dialog.name, Dialog)
}
export {Modal,Modals,Dialog}
